import { markRaw } from 'vue'

const initialState = () => ({
  adminModulesPermissions: markRaw([])
})
export default initialState
